import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import useFetch from "../hook/useFetch";

const apiBase = process.env.NODE_ENV === "development"
  ? "/api"
  : `${process.env.REACT_APP_API}/api`;

export default function TwoFactor() {
  const { get, post, error } = useFetch();
  const [status, setStatus] = useState(null);
  const [code, setCode] = useState("");
  const [backupCodes, setBackupCodes] = useState([]);
  const navigate = useNavigate();

  useEffect(() => {
    get("/admin/2fa", null, () => navigate("/login"), data => {
      if (data.verified) {
        navigate("/admin");
        return;
      }
      setStatus(data);
    });
  }, []);

  if (!status) {
    return <div className="login-container"><p>Loading two-factor authentication …</p></div>;
  }

  const route = status.configured ? "/admin/2fa/verify" : "/admin/2fa/confirm";
  const submit = event => {
    event.preventDefault();
    post(route, { code }, null, data => {
      if (data.backup_codes?.length) {
        setBackupCodes(data.backup_codes);
        return;
      }
      navigate("/admin");
    });
  };

  return <div className="login-container">
    <section className="login-form shadow">
      <h1>{status.configured ? "Enter 2FA code" : "Set up 2FA"}</h1>
      {!status.configured && <>
        <p>Scan the QR code with an authenticator app, then enter the six-digit code.</p>
        <img src={`${apiBase}/admin/2fa/qrcode`} width="240" height="240" alt="2FA QR code" crossOrigin="use-credentials" />
      </>}
      {status.configured && <p>Noch {status.backup_codes_remaining} unbenutzte Backup-Codes.</p>}
      {error && <p className="alert alert-danger">{String(error)}</p>}
      {!backupCodes.length && <form onSubmit={submit}>
        <input className="form-control" name="code" inputMode="numeric" autoComplete="one-time-code" value={code} onChange={event => setCode(event.target.value)} required />
        <button className="btn btn-primary" type="submit">Confirm</button>
      </form>}
      {!!backupCodes.length && <div>
        <p className="alert alert-warning">These backup codes are shown only once. Store them securely.</p>
        <ul>{backupCodes.map(item => <li key={item}><code>{item}</code></li>)}</ul>
        <button className="btn btn-primary" onClick={() => navigate("/admin")}>Continue to dashboard</button>
      </div>}
    </section>
  </div>;
}
